
import { Component, OnDestroy, ElementRef } from '@angular/core';

// Models
import { ModalID } from '../../models/constants';
// Service
import { SharedService } from '../../services/shared.service';
@Component({
    selector: 'app-user-credentials',
    templateUrl: './user-credentials.component.html',
    styleUrl: './user-credentials.component.scss',
    standalone: true,
    imports: []
})
export class UserCredentialsComponent implements OnDestroy {
  message: string;
  error: boolean = false;
  error_message ='Username or Password is incorrect';
  html: string;
  ok_button: string = 'Exit Kiosk Mode';
  cancel_button: string = 'Cancel Form';
  exit_kiosk: boolean = false;

  constructor(
    protected element: ElementRef,
    public sharedService: SharedService,
  ) {

  }

  onInitialize(): void {
    // console.log(this.message, this.error, this.html);
  }
  cancelClick() {
    this.sharedService.closeModal(ModalID.user_credentials);
    this.sharedService.reset_4473_buyer$.next(true);
  }

  okClick() {
    this.exit_kiosk = true;
    // if(this.verifyCredentials()) {
    //   this.sharedService.closeModal(ModalID.user_credentials);
    //   this.sharedService.kiosk_mode = false;
    //   this.sharedService.changeRoute('home');
    // } else {
    //   this.error = true;
    // }
  }
  exitKiosk() {
       if(this.verifyCredentials()) {
      this.sharedService.closeModal(ModalID.user_credentials);
      this.sharedService.kiosk_mode = false;
      this.sharedService.changeRoute('home');
    } else {
      this.error = true;
    }
  }

  verifyCredentials() { // need to create this function
    this.error = false;
    return true;
  }
 
  ngOnDestroy() {
    //    this.sub.unsubscribe();
    }

}
